import { makeStyles } from "@material-ui/styles";
import { CELL_WIDTHS, TIMELINE_MONTH_HEADER_HEIGHT } from "@utils";

const width = (expanded) => (
  expanded ? CELL_WIDTHS.TITLE_LARGE : CELL_WIDTHS.TITLE_NORMAL
) + CELL_WIDTHS.DRAG_HANDLE

export default makeStyles((theme) => ({
  root: {
    position: "relative",
    width: width(),
    minWidth: width(),
    "& > *": { width: "100%", minWidth: 0 },
    borderRightStyle: "dashed !important",
    borderRightWidth: "1px !important",
    borderRightColor: "transparent",
    boxSizing: "content-box",
    transition: "width 250ms",
    paddingBottom: 16,
    flexShrink: 0,
  },
  expanded: {
    width: width(true),
  },
  pinnedCell: {
    height: TIMELINE_MONTH_HEADER_HEIGHT,
    minHeight: TIMELINE_MONTH_HEADER_HEIGHT,
    position: "relative",
    zIndex: 5,
    backgroundColor: theme.props.backgroundSecondary,

  },
  collapseExpanded: {
    position: "absolute",
    top: 0,
    right: 4,
    zIndex: 2,
    display: "flex",
    justifyContent: "flex-end",
    pointerEvents: "none",
    "& button": {
      pointerEvents: "auto",
    },
  },
  border: {
    borderRightColor: `${ theme.props.border } !important`,
  }
}));
